import { createStyles } from "@mantine/emotion";

export const useStylesContainer = createStyles((theme) => ({
  container: {
    maxWidth: theme.spacing.container.maxWidth,
    width: theme.spacing.container.width.default,
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      width: theme.spacing.container.width.mobile,
    },
    "&.relative": {
      position: "relative",
    },
  },
}));
